import React, { useRef } from "react";
import { Bold, Italic, List, ListOrdered } from "lucide-react";

/* Mini editor: markup leggero (**grassetto**, *corsivo*, "- " elenco, "1. " numerato) riprodotto in PDF e Word. */
export const RichTextArea = ({ value = "", onChange, testId, rows = 4 }) => {
  const ref = useRef(null);
  const apply = (next, start, end) => {
    onChange(next);
    requestAnimationFrame(() => { ref.current?.focus(); ref.current?.setSelectionRange(start, end); });
  };
  const wrap = marker => {
    const el = ref.current, { selectionStart: a, selectionEnd: b } = el;
    const inner = value.slice(a, b) || "testo";
    apply(value.slice(0, a) + marker + inner + marker + value.slice(b), a + marker.length, a + marker.length + inner.length);
  };
  const prefixLines = numbered => {
    const el = ref.current;
    const start = value.lastIndexOf("\n", el.selectionStart - 1) + 1;
    const endIndex = value.indexOf("\n", el.selectionEnd);
    const end = endIndex === -1 ? value.length : endIndex;
    const lines = value.slice(start, end).split("\n").map((line, i) => {
      const clean = line.replace(/^\s*(?:[-•*]|\d+[.)])\s+/, "");
      return numbered ? `${i + 1}. ${clean}` : `- ${clean}`;
    });
    const block = lines.join("\n");
    apply(value.slice(0, start) + block + value.slice(end), start, start + block.length);
  };
  const tools = [["bold", Bold, "Grassetto", () => wrap("**")], ["italic", Italic, "Corsivo", () => wrap("*")],
    ["bullets", List, "Elenco puntato", () => prefixLines(false)], ["numbers", ListOrdered, "Elenco numerato", () => prefixLines(true)]];
  return <div className="rich-area">
    <div className="rich-toolbar" role="toolbar" aria-label="Formattazione testo">
      {tools.map(([key, Icon, title, run]) => <button type="button" key={key} title={title} aria-label={title}
        data-testid={`${testId}-tool-${key}`} onMouseDown={event => event.preventDefault()} onClick={run}><Icon size={14} /></button>)}
      <small>**grassetto** · *corsivo* · "- " punto elenco</small>
    </div>
    <textarea ref={ref} rows={rows} data-testid={testId} value={value} onChange={event => onChange(event.target.value)} />
  </div>;
};
